import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsRoutingModule } from './settings-routing.module';
import { RatesPageComponent } from './pages/rates-page/rates-page.component';
import { CreateRateModalComponent } from './components/create-rate-modal/create-rate-modal.component';
import { SharedModule } from '../shared/shared.module';
import { SharedManagerModule } from '../shared-manager/shared-manager.module';
import { SettingsPageComponent } from './pages/settings-page/settings-page.component';
import { CancelConditionsPageComponent } from './pages/cancel-conditions-page/cancel-conditions-page.component';
import { CommunicationTemplatesPageComponent } from './pages/communication-templates-page/communication-templates-page.component';
import { CommunicationTemplateFormComponent } from './components/communication-template-form/communication-template-form.component';
import { CancelConditionsFormComponent } from './components/cancel-conditions-form/cancel-conditions-form.component';
import { GracePeriodFormComponent } from './components/grace-period-form/grace-period-form.component';
import { TestModePageComponent } from './pages/test-mode-page/test-mode-page.component';
import { AuthenticationSettingsPageComponent } from './pages/authentication-settings-page/authentication-settings-page.component';
import { CalendarConstraintsPageComponent } from './pages/calendar-constraints-page/calendar-constraints-page.component';
import { PaymentMethodsPageComponent } from './pages/payment-methods-page/payment-methods-page.component';
import { CreatePaymentMethodModalComponent } from './components/create-payment-method-modal/create-payment-method-modal.component';
import { AdminTabsComponent } from './components/admin-tabs.component';
import { FormFieldsetComponent } from '../shared/components/form-fieldset.component';

@NgModule({
  declarations: [
    SettingsPageComponent,
    RatesPageComponent,
    RatesPageComponent,
    CreateRateModalComponent,
    CancelConditionsPageComponent,
    CommunicationTemplatesPageComponent,
    CommunicationTemplateFormComponent,
    CancelConditionsFormComponent,
    GracePeriodFormComponent,
    TestModePageComponent,
    AuthenticationSettingsPageComponent,
    CalendarConstraintsPageComponent,
    PaymentMethodsPageComponent,
    CreatePaymentMethodModalComponent,
    AdminTabsComponent,
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    SharedModule,
    SharedManagerModule,
    FormFieldsetComponent,
  ],
  exports: [
    AdminTabsComponent,
  ],
})
export class SettingsModule {}
